

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "./Slider.css";









export default function Slide() {
    var settings = {
        className: "center",
        arrows:false,
        centerMode: false,
        centerPadding: "60px",
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        cssEase: "linear",
        dotsClass: 'Slider-dots',
        
        
        responsive: [            
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]


    };
    return (
        <div className="sli">
            <Slider {...settings}>

                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-1.jpeg"
                        alt=" "

                    />
                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-2.jpeg"
                        alt=" "

                    />
                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-3.jpeg"
                        alt=" "

                    />

                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-4.jpeg"
                        alt=" "

                    />

                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-5.jpeg"
                        alt=" "

                    />

                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-6.jpeg"
                        alt=" "

                    />

                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-7.jpeg"
                        alt=" "

                    />

                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-8.jpeg"
                        alt=" "

                    />

                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-9.jpeg"
                        alt=" "

                    />

                </div>
                <div>
                    <img className="photo"
                        src="/assets/slider/Signal-Boost-10.jpeg"
                        alt=" "

                    />

                </div>                
            </Slider>
        </div>
    );
}
